export const CASE_CONSULTATIONS = {
    CONSULTATION_SENT: {
        code: 'CONSULTATION_SENT',
        url: 'casesWithConsultationSentByMe',
        exportUrl: 'exportCasesWithConsultationSentByMeGrid'
    },
    CONSULTATION_SENT_SOLVED: {
        code: 'CONSULTATION_SENT_SOLVED',
        url: 'casesWithSolvedConsultationSentByMe',
        exportUrl: 'exportCasesWithSolvedConsultationSentByMeGrid'
    },
    CONSULTATION_RECEIVED: {
        code: 'CONSULTATION_RECEIVED',
        url: 'casesWithConsultationReceivedByMe',
        exportUrl: 'exportCasesWithConsultationReceivedByMeGrid'
    },
    CONSULTATION_RECEIVED_SOLVED: {
        code: 'CONSULTATION_RECEIVED_SOLVED',
        url: 'casesWithSolvedConsultationReceivedByMe',
        exportUrl: 'exportCasesWithSolvedConsultationReceivedByMeGrid'
    }
}
